import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { getValue } from './input.utils';

export type UseStylesProps = {
  success?: boolean;
  boldLabel?: boolean;
  required?: boolean;
  warning?: boolean;
  filter?: boolean;
};

export const useStyles = makeStyles<Theme, UseStylesProps>(({ palette, spacing }) => ({
  root: {
    width: '100%',
    fontSize: spacing(2),
    lineHeight: spacing(3),
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: palette.gray.dark,
    },
    '& .MuiInputLabel-outlined': {
      pointerEvents: 'visible',
    },
    '& .MuiFormLabel-root': {
      transform: 'none',
      transition: 'none',
      transformOrigin: 'unset',
      position: 'initial',
      lineHeight: ({ filter }) => filter && spacing(3),
      marginBottom: spacing(1),
      color: palette.black.main,
      fontWeight: ({ boldLabel }) => getValue({ condition: boldLabel, value: 'bold', defaultValue: 'normal' }),
      '& .MuiFormLabel-asterisk': {
        color: palette.primary.main,
        display: ({ required }) => !required && 'none',
      },
    },
    '& .MuiOutlinedInput-root': {
      fontSize: spacing(2.25),
      lineHeight: ({ filter }) => (filter ? spacing(3) : spacing(3.5)),
      marginRight: ({ filter }) => filter && spacing(2),
      borderRadius: spacing(0.75),
      '& .MuiOutlinedInput-input': {
        padding: spacing(1.5, 1.75),
        height: spacing(3),
      },
      '& .MuiOutlinedInput-inputMultiline': {
        padding: 0,
        height: 'auto',
      },
      '& fieldset': {
        borderColor: ({ success, warning }) =>
          `${warning ? palette.orange.main : success ? palette.success.main : palette.gray.main}`,
        borderWidth: spacing(0.25),
        '& legend': {
          width: 0,
        },
      },
      '& input': {
        '&::placeholder': {
          color: palette.gray.dark,
        },
        minWidth: ({ filter }) => filter && spacing(33),
      },
      '&:not(.Mui-error):not(.Mui-disabled)': {
        '&:hover fieldset': {
          borderColor: ({ success, warning }) =>
            `${warning ? palette.orange.main : success ? palette.success.main : palette.gray.main}`,
        },
        '&.Mui-focused fieldset': {
          borderColor: ({ success, warning }) =>
            `${warning ? palette.orange.main : success ? palette.success.main : palette.focus.main}`,
        },
      },
      '& .Mui-disabled': {
        backgroundColor: palette.gray.main,
      },
    },
    '& .MuiFormHelperText-root': {
      margin: spacing(1, 0, 0),
      fontStyle: 'normal',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      display: 'flex',
      alignItems: 'center',
      '&:not(.Mui-error)': {
        color: ({ success, warning }) =>
          `${warning ? palette.orange.main : success ? palette.success.main : palette.gray.dark}`,
        '& svg': {
          color: palette.orange.main,
        },
      },
      '& svg': {
        color: 'red',
      },
    },
  },
  checkIcon: {
    color: palette.success.main,
  },
}));
